<template>
    <div>
        <rkm-area
            title="Identificação do veículo"
            type="section"
            no-margin-top
        >
            <rkm-row>
                <rkm-col cols="3">
                    <rkm-form-input
                        label="Placa"
                        v-model="form.veiculo.numeroPlaca"
                        type="text"
                        uppercase
                        disabled
                    />
                </rkm-col>

                <rkm-col cols="3">
                    <rkm-form-input
                        label="Marca"
                        v-model="form.veiculo.descricaoMarca"
                        type="text"
                        uppercase
                        disabled
                    />
                </rkm-col>

                <rkm-col cols="3">
                    <rkm-form-input
                        label="Modelo"
                        v-model="form.veiculo.descricaoModelo"
                        type="text"
                        uppercase
                        disabled
                    />
                </rkm-col>

                <rkm-col cols="3">
                    <rkm-form-input
                        label="Tipo de veículo"
                        v-model="form.veiculo.descricaoTipo"
                        type="text"
                        upperase
                        disabled
                    />
                </rkm-col>
            </rkm-row>

            <rkm-row>
                <rkm-col cols="3">
                    <rkm-form-input
                        label="Tipo de passageiro"
                        v-model="form.veiculo.passageiroDescricaoTipo"
                        type="text"
                        uppercase
                        disabled
                    />
                </rkm-col>

                <rkm-col cols="3">
                    <rkm-form-input
                        label="Capacidade"
                        v-model="form.veiculo.numeroCapacidade"
                        type="text"
                        uppercase
                        disabled
                    />
                </rkm-col>

                <rkm-col cols="3">
                    <rkm-form-input
                        label="Ano de fabricação"
                        v-model="form.veiculo.anoFabricacao"
                        type="text"
                        uppercase
                        disabled
                    />
                </rkm-col>

                <rkm-col cols="3">
                    <rkm-form-input
                        label="Cor predominante"
                        v-model="form.veiculo.descricaoCor"
                        type="text"
                        uppercase
                        disabled
                    />
                </rkm-col>
            </rkm-row>
        </rkm-area>

        <Buscar
            :form="form"
            :model="model"
            :tabIndex="tabIndex"
            @handleBlur="handleBlur"
        />

        <Atribuir
            v-if="model.jornadasNotSave"
            :form="form"
            :model="model"
            :selecionados="selecionados"
            @getCalendar="getCalendar"
        />

        <rkm-row v-if="model.jornadasNotSave">
            <rkm-col>
                <rkm-button
                    @click="selecionarTodos()"
                    color="primary"
                    class="mb-2"
                >
                    <template v-if="selecionados == false">
                        Selecionar todos
                    </template>

                    <template v-else>
                        Desmarcar selecionado(s)
                    </template>
                </rkm-button>

                <template>
                    <rkm-button
                        v-if="selecionados == true"
                        @click="deletarSelecionados()"
                        color="danger"
                        class="mb-2"
                    >
                        Excluir selecionado(s)
                    </rkm-button>
                </template>
            </rkm-col>
        </rkm-row>


        <rkm-table
            v-if="model.jornadasNotSave"
            :fields="fields"
            :items="model.jornadasNotSave"
            ref="Table"
            hide-filters
            sortBy="dataInicial"
        >

            <template v-slot:cell(checkbox)="{ item }">
                <rkm-form-checkbox
                    v-model="item.selecionado"
                    :disabled="item.vinculo"
                    @change="handleBlur"
                />
            </template>

            <template v-slot:cell(dataInicial)="row">
                {{ row.value | formatDateTime }}
            </template>

            <template v-slot:cell(dataFinal)="row">
                {{ row.value | formatDateTime }}
            </template>

            <template v-slot:cell(actions)="{ index, item }">

                <rkm-button
                    color="primary"
                    title="Editar"
                    small
                    @click.stop="$emit('handleAlter', item, index)"
                >
                    <rkm-icon icon="pen" />
                </rkm-button>

                <rkm-button
                    @click="handleDestroy(item)"
                    color="danger"
                    small
                    title="Excluir"
                >
                    <rkm-icon icon="trash"/>
                </rkm-button>
            </template>
        </rkm-table>
    </div>
</template>

<script>

// Filters.
import formats from '@/filters/formats'

import { mapActions } from 'vuex'
import { repository, error, object, data, stringCase } from '@/mixins'

// Components.
import Buscar from '@/components/transporte-paciente/jornada/components/buscar/Form'
import Atribuir from '@/components/transporte-paciente/jornada/components/Atribuir'

export default {
    components:{ Buscar, Atribuir },
    filters: {
        formatDateTime: formats.formatDateTime,
        formatPlaca: formats.numeroPlaca,
    },
    computed:{
        fields() {
            return [
                {
                    key: 'checkbox',
                    label: '#',
                    class: 'col-min text-center',
                },
                {
                    key: 'geralDiaSemanaDescricao',
                    label: 'Dia da semana',
                    name: 'geralDiaSemanaDescricao',
                    searchable: true,
                    sortable: true,
                },
                {
                    key: 'dataInicial',
                    label: 'Data e hora inicial',
                    name: 'dataInicial',
                    searchable: true,
                    sortable: true,
                },
                {
                    key: 'dataFinal',
                    label: 'Data e hora final',
                    name: 'dataFinal',
                    searchable: true,
                    sortable: true,
                },
                {
                    class: 'col-min text-center',
                    key: 'actions',
                    label: 'Ações',
                    sortable: true,
                },
            ];
        },
    },
    created() {
        this.repositories = {
            jornada: this.getConectaSusRepository('transportePaciente.jornada')
        }
    },
    data:() => ({
        selecionados: false,
        jornada: {
            data: null,
            horaInicial: '',
            horaFim: '',
            diasSemana: null,
            semanaId: null,
            selecionado: false,
            periodo: {
                start: null,
                end: null,
            },
        },
        isReadOnly: false,
    }),
    mixins: [ repository, error, object, data, stringCase ],
    methods: {
        ...mapActions(['setLoading', 'unsetLoading']),
        validate() {
            return this.$refs.Form.validate()
        },
        handleDestroy(item) {
            if(item.vinculo) {
                this.showAlert('O registro possui vínculos e não pode ser excluido.', 'Atenção!')
                return
            }
            const destroy = async () => {
                this.setLoading()
                this.repositories.jornada.destroy(item.id)
                    .then(() => {
                        const objId = this.model.jornadas.findIndex((obj => obj.id == item.id))
                        this.model.jornadas.splice(objId, 1)
                        if (this.model.jornadasNotSave && this.model.jornadasNotSave.length > 0) {
                            const objIndex = this.model.jornadasNotSave.findIndex((obj => obj.id == item.id));
                            this.model.jornadasNotSave.splice(objIndex, 1)
                        }
                        this.$emit('loadDays', this.model.jornadas)
                        this.handleBlur()
                    })
                    .catch(this.handleError)
                    .finally(() => this.unsetLoading())
            }

            this.showDeleteConfirmation(`Deseja realmente excluir essa jornada?`, destroy)

        },
        selecionarTodos(){

            if(this.selecionados == false){

                if(this.model.jornadasNotSave.every(jornada => jornada.vinculo)) {
                    this.showAlert('Todas as jornadas possuem vínculo e não podem ser excluidas.', 'Atenção')
                    return
                }
                this.selecionados = true
                this.model.jornadasNotSave.map(jornada => {
                    if(!jornada.vinculo) {
                        jornada.selecionado = true
                    }
                    return jornada
                })
            } else {

                this.selecionados = false
                this.model.jornadasNotSave.map(jornada => (jornada.selecionado = false))
            }
        },
        deletarSelecionados(){

            if(this.selecionados == false){

                this.showAlert('É necessário selecionar uma jornada')

            } else {
                let jornadasComVinculo = this.model.jornadas.filter(jornada => jornada.selecionado && jornada.vinculo)
                let jornadasSemVinculo = this.model.jornadas.filter(jornada => jornada.selecionado && !jornada.vinculo)
                const destroy = async () => {
                    if(jornadasSemVinculo.length > 0) {
                        this.setLoading()
                        this.repositories.jornada.destroySelected({
                            ids: jornadasSemVinculo.map(jornada => jornada.id)
                        })
                            .then(() => {
                                this.model.jornadas = this.model.jornadas.filter(jornada => !jornada.selecionado || (jornada.selecionado && jornada.vinculo))
                                if (this.model.jornadasNotSave && this.model.jornadasNotSave.length > 0) {
                                    this.model.jornadasNotSave = this.model.jornadasNotSave.filter(jornada => !jornada.selecionado || (jornada.selecionado && jornada.vinculo))
                                }
                                if(jornadasComVinculo.length > 0) {
                                    this.showAlert('Os registros selecionados possuem vínculos e não podem ser excluídos.', 'Atenção!')
                                }
                                this.$emit('loadDays', this.model.jornadas)
                                this.handleBlur()
                            })
                            .catch(this.handleError)
                            .finally(() => {
                                this.unsetLoading()
                            })
                    } else if(jornadasComVinculo.length > 0) {
                        this.$nextTick().then(() => this.showAlert('Os registros selecionados possuem vínculos e não podem ser excluídos.', 'Atenção!'))
                    }
                }

                this.showDeleteConfirmation(`Deseja realmente excluir a(s) jornada(s) selecionada(s)?`, destroy)
            }
        },
        handleBlur(){

            let selecionado = false

            this.model.jornadasNotSave.map(jornada => {

                if (jornada.selecionado == true) {

                    selecionado = true
                }
            })

            if (selecionado) {

                this.selecionados = true
            } else {

                this.selecionados = false
            }
        },
        getCalendar() {

            this.$emit('loadDays', this.model.jornadas)
        }
    },
    props: {
        form: { type: Object, required: true },
        model: { type: Object, required: true },
        jornadas: { type: Array, required: true },
        id: { type: Number },
        tabIndex: { type: Number },
    },
}
</script>